import { YesNoIndicators } from '../../../global/models/api-model';

export enum ClergyBioContext {

	SUMMARY = 'SUMMARY',

}

export enum ClergyBioActionTypes {
	SET_CLERGY_BIO_ECCLESIASTICS = 'SET_CLERGY_BIO_ECCLESIASTICS',
	SET_CLERGY_BIO_PERSONAL_INFO = 'SET_CLERGY_BIO_PERSONAL_INFO',
	SET_CLERGY_BIO_RELATIONSHIP = 'SET_CLERGY_BIO_RELATIONSHIP',
	SET_CLERGY_BIO_MINISTRIES = 'SET_CLERGY_BIO_MINISTRIES',
	SET_CLERGY_BIO_PROFESSIONAL = 'SET_CLERGY_BIO_PROFESSIONAL',
	SET_CLERGY_BIO_EDUCATION = 'SET_CLERGY_BIO_EDUCATION',
	SET_CLERGY_BIO_VOLUNTEER = 'SET_CLERGY_BIO_VOLUNTEER',
	SET_CLERGY_BIO_CHURCH_REPORT = 'SET_CLERGY_BIO_CHURCH_REPORT',
	SET_CLERGY_BIO_LOADINGSTATE = 'SET_CLERGY_BIO_LOADINGSTATE',
	SET_CLERGY_BIO_INSTITUTIONS = 'SET_CLERGY_BIO_INSTITUTIONS',

}
export interface CleryBioPersonInfo {
	personal: {
		title: string;
		published: boolean;
		details: {
			religiousOrder: string;
			placeOfBirth: string;
			firstName: string;
			firstNamePub: string;
			middleName: string;
			middleNamePub: string;
			lastName: string;
			lastNameAtBirth: string;
			personalWebsite: {
				url: string;
			}
		}
	},
	publishedAddress: {
		title: string;
		published: boolean;
		details: {
			deactivated: boolean;
			address1: string;
			address2: string;
			address3: string;
			city: string;
			state: string;
			postalCode: string;
			country: string;
			errors: any;
		}
	},
	isNewClergy: boolean;
	ordinationInfoOnly: YesNoIndicators,
	error: any;
}

export interface ClergyBioChurchRerpot {
	title: string;
	published: boolean;
	details: {
		ethnicities: string[];
		sexualOrientations: string[];
		genderIdentities: string[];
		ethnicitySpecify: string;
		sexualSpecify: string;
		genderSpecify: string;
	}
}




export interface RelationshipPerson {
	id?: number;
	firstName: string;
	middleName: string;
	lastName: string;
	lastNameAtBirth?: string;
	gender: string;
	suffix: string;
	dob: string;
	dom?: string;
	stepchild?: YesNoIndicators;
	removable?: boolean;
	errors?: any;
}

export interface ClergyBioChurchRelationship {
	parents: {
		title: string;
		published: boolean;
		details: RelationshipPerson[];

	},
	currentSpouse: {
		title: string;
		published: boolean;
		details: RelationshipPerson[];

	},
	previousSpouse: {
		title: string;
		published: boolean;
		details: RelationshipPerson[];

	},
	deceasedSpouse: {
		title: string;
		published: boolean;
		details: RelationshipPerson[];

	},
	children: {
		title: string;
		published: boolean;
		details: RelationshipPerson[];

	},
}

export interface Education {
	id?: number;
	field: string;
	degree: string;
	institution: string;
	action?: string;
	year: number | string;
	degreeOther: string;
	institutionOther: string;
	errors?: any;
}

export interface ClergyBioChurchEducation {
	theological: {
		title: string;
		published: boolean;
		details: Education[];
	},
	other: {
		title: string;
		published: boolean;
		details: Education[];
	},
	error: any,
}


export interface ClergyBioPosition {
	id?: number;
	position: string;
	publishedPosition: string;
	dateBegan: string;
	dateEnded: string;
	deleted: string;
	errors?: any;
}

export interface ClergyBioMinistry {
	id?: number;
	dateBegan: string;
	dateEnded: string;
	deleted: string;
	institutionInfo: {
		id?: number | string;
		name: string;
		location: string;
	},
	positions: ClergyBioPosition[];
	institutionParsed?: string;
	errors?: any;
}

export interface ClergyBioMiscellaneous {
	id?: string;
	dateBegan: string;
	dateEnded: string;
	institutionInfo: string;
	position: string;
	deleted: string;
	positions?: ClergyBioPosition[];
	errors?: string;
}

export interface ClergyBioChurchMinistries {
	stipendiary: {
		title: string;
		published: boolean;
		details: ClergyBioMinistry[];
	};
	nonStipendiary: {
		title: string;
		published: boolean;
		details: ClergyBioMinistry[];
	};
	miscellaneous: {
		title: string;
		published: boolean;
		details: ClergyBioMiscellaneous[];
	};
	error: any;
}

export interface InstitutionInfo {
	id: number | string;
	name: string;
	location: string;
}

export interface ClergyBioVolunteer {
	id: number;
	employeeId: number;
	employerId: number;
	dateBegan: string;
	dateEnded: string;
	position: string;
	institutionInfo: InstitutionInfo | string;
	institutionParsed?: string;
	deleted?: YesNoIndicators;
	errors?: any;
}

export interface ClergyBioChurchVolunteer {
	episcopal: {
		title: string;
		published: boolean;
		details: ClergyBioVolunteer[];
	};
	miscellaneous: {
		title: string;
		published: boolean;
		details: ClergyBioVolunteer[];
	};
	error: any;
}

export interface CleryBioProfessionalItem {
	id: number;
	role?: string;
	title?: string;
	publication?: string;
	publisher?: string;
	action?: string;
	year?: string;
	organization?: string;
	errors?: any;
	startYear?: string;
	endYear?: string;
	honor?: string;
	name?: string;
}

export interface ClergyBioChurchProfessional {
	error: any;
	publications: {
		title: string;
		published: boolean;
		details: CleryBioProfessionalItem[];
	};
	honors: {
		title: string;
		published: boolean;
		details: CleryBioProfessionalItem[];
	};
	societies: {
		title: string;
		published: boolean;
		details: CleryBioProfessionalItem[];
	};
	optOut: boolean;
}

export enum DataState {
	EMPTY,
	LOADING,
	ERROR,
	LOADED,
}

export interface LoadingState {
	personInfo: DataState;
	churchReport: DataState;
	relationship: DataState;
	education: DataState;
	ministries: DataState;
	volunteer: DataState;
	professional: DataState;
	ecclesiastics: DataState;
	institutions?: DataState;
}

export interface EcclesiaticDetail {
	date?: string;
	by?: string;
	for?: string;
	coConsecrators?: any[]
}
export interface Ecclesiatics {
	canonical: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	},
	diaconate: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	},
	priesthood: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	},
	reception: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	},
	transfer: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	},
	consecration: {
		title: string;
		published: boolean;
		details: EcclesiaticDetail;
	}
}

export interface ClergyBioAppState {
	ecclesiastics: Ecclesiatics;
	context: ClergyBioContext;
	personInfo: CleryBioPersonInfo;
	churchReport: ClergyBioChurchRerpot;
	relationship: ClergyBioChurchRelationship;
	education: ClergyBioChurchEducation;
	ministries: ClergyBioChurchMinistries;
	volunteer: ClergyBioChurchVolunteer;
	professional: ClergyBioChurchProfessional;
	institutions?: any;
	loaded: LoadingState;
}

export class ClergyBioRoutes {

	public static readonly Personal: string = '/personal';

	public static readonly Summary: string = '/summary';

	public static readonly ChurchReporting: string = '/church-reporting';

	public static readonly Relationships: string = '/relationships';

	public static readonly Education: string = '/education';

	public static readonly Ministry: string = '/ministry';

	public static readonly Professional: string = '/professional';

	public static readonly Volunteer: string = '/volunteer';

}
